import { Component, OnInit, Input } from '@angular/core';

import { Product } from '@app/core/products/store/product.model';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { environment } from '@app/env-service';

import { PrintService } from '../services/print.service';

@Component({
  selector: 'cnc-print-product',
  templateUrl: './print-product.component.html',
  styleUrls: ['./print-product.component.scss'],
})
export class PrintProductComponent implements OnInit {
  url :string = environment.url;
  pageTitle :string = 'View Product';

  product :any;
  tieredPricing :any = [];
  variantPricing :any = [];

  constructor(
    private printSvc :PrintService,
    public settingsSvc :SettingsService,
  ) {}

  ngOnInit() {
    this.product = this.printSvc.toPrintData;

    this.tieredPricing = JSON.parse(this.product.tiered_pricing_json);
    this.variantPricing = JSON.parse(this.product.variant_prices_json);

    this.loadImages(this.product.images);
  }

  loadImages(images ?:any) {
    if (!images || images.length == 0) {
      setTimeout(() => {
        this.printSvc.onDataReady();
      }, 1);
    }
    let totalImages :number = images.length;

    images.forEach((file :any) => {
      const img = new Image();
      img.onload = (e) => {
        totalImages -= 1;
        if (totalImages <= 0) {
          setTimeout(() => {
            this.printSvc.onDataReady();
          }, 10);
        }
      };
      img.onerror = (e) => {
        totalImages -= 1;
        if (totalImages <= 0) {
          setTimeout(() => {
            this.printSvc.onDataReady();
          }, 10);
        }
      };
      img.src = this.url + '/file?f=' + file.filename;
    });
  }
}
